import { useActaPartido } from './useActaPartido';
import { advancedReferenceCode, matchingAdvancedActa } from '../../utils/advancedStatistics';

export default function useAdvancedMatch(record) {
  const code = advancedReferenceCode(record);
  const query = useActaPartido(record?.idTemporada, code, {
    enabled: Boolean(record?.idTemporada && code),
  });
  return { ...query, acta: matchingAdvancedActa(record, query.data) };
}
